import generateConfig from 'rc-picker/lib/generate/dayjs';

import 'dayjs/locale/de';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

dayjs.locale('de_DE');

const LocalizedDatePicker = DatePicker.generatePicker<Dayjs>(generateConfig);

export default LocalizedDatePicker;